<template>
  <div id="app">
    <mpr-menu />
    <router-view/>
  </div>
</template>

<style>
body {
  margin: 0;
  background-color: #f5f5f5;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  text-align:center;
}
#app:fullscreen::backdrop {
    background-color: #f5f5f5;
}
#app iframe {
  height: calc(100vh - 27px);
}
</style>

<script>
import Menu from '@/components/Menu';

window.LOG_LEVEL = 'ERROR';

export default {
  name: 'app',
  components: {
    'mpr-menu': Menu
  }
}
</script>